import { useState } from "react";
import { usePage, router } from "@inertiajs/react";
import { Button } from "@/components/ui/button";
import { RefreshCw } from "lucide-react";

export default function SyncBggButton({ onSyncingChange }) {
  const { routes, auth } = usePage().props;
  const [syncing, setSyncing] = useState(false);
  const hasBgg = !!auth.user?.bgg_username;

  function sync() {
    setSyncing(true);
    onSyncingChange?.(true);
    router.post(routes.sync_library, {}, {
      preserveScroll: true,
      onFinish: () => {
        setSyncing(false);
        onSyncingChange?.(false);
      },
    });
  }

  if (hasBgg) {
    return (
      <Button variant="outline" size="sm" onClick={sync} disabled={syncing}>
        <RefreshCw className={`h-4 w-4 ${syncing ? "animate-spin" : ""}`} />
        {syncing ? "Syncing…" : "Sync BGG"}
      </Button>
    );
  }

  return (
    <Button variant="outline" size="sm" asChild>
      <a href={routes.settings}>Add BGG username</a>
    </Button>
  );
}
